import axios from 'axios';
import properties from '../properties';

export interface CareQualityMeasures {
  benchMarkDistribution: BenchMarkDistribution;
  distribution: Distribution[];
}

export interface BenchMarkDistribution {
  currentYear: CategoriesDataType;
  previousYear: CategoriesDataType;
}

export interface CategoriesDataType {
  good: string[];
  average: string[];
  need_intervention: string[];
}

export interface Distribution {
  subMeasure: string;
  individualMeasures: IndividualMeasure[];
  rank: string;
}

export interface IndividualMeasure {
  subMeasure: string;
  individualMeasure: string;
  measureMetCount: number;
  measureNotMetCount: number;
  measureNotMetCountIds: string[];
  eligibleCount: number;
  nationalScore: number;
  ruleId: string;
  measureScore: number;
  prevYearScore: number;
  rank: string;
  prevRank: string;
}

export interface CareQualityOverView {
  totalMetUnmet: number;
  totalMet: number;
  totalUnmet: number;
  totalEnrolles: number;
}
export const getCareQualityDistributions = async (
  requestBody: any,
  setAllDistributionsFunction: any,
  setBenchMarkDistribution: any,
  setIsAllDataAvailable: any,
) => {
  await axios
    .post(
      properties.aiqBaseUrl +
        properties.careQualityBasicUrl +
        properties.distribution,
      requestBody,
    )
    .then((res) => {
      if (res?.status === 200) {
        setIsAllDataAvailable(res?.data?.data?.isAllDataAvailable);
        if (res?.data?.data?.isAllDataAvailable) {
          const formattedData = formatCareQualityMeasures(res?.data?.data);
          setAllDistributionsFunction(formattedData);
          setBenchMarkDistribution
            ? setBenchMarkDistribution(formattedData)
            : '';
        }
      }
    })
    .catch((error) => {
      return error;
    });
};

export const getCareQualityOverViewCardData = async (
  requestBody: any,
  setCareQualityOverview: any,
) => {
  await axios
    .post(
      properties.aiqBaseUrl +
        properties.careQualityBasicUrl +
        properties.summary,
      requestBody,
    )
    .then((res) => {
      if (res?.status === 200) {
        setCareQualityOverview(res?.data?.data);
      }
    })
    .catch((error) => {
      return error;
    });
};

export const formatCareQualityMeasures = (data: any) => {
  const distributions: Distribution[] = data?.distribution;
  const benchMarkCategories: BenchMarkDistribution =
    data?.benchMarkDistribution;

  const careQualityMeasures: CareQualityMeasures = {
    benchMarkDistribution: benchMarkCategories,
    distribution: distributions,
  };

  return careQualityMeasures;
};

export const formatBenachMarkChart = (data: BenchMarkDistribution) => {
  const chartData: any = {
    categories: [
      {
        name: 'Good - >90th%',
      },
      {
        name: 'Average - 50th-90th%',
      },
      {
        name: 'Need Intervention - <50th%',
      },
    ],
    currentYearData: [
      {
        id: 'curr-good',
        value: data?.currentYear?.good?.length,
        color: '#BDDEDA',
        ruleIds: data?.currentYear?.good,
        link: ' ',
      },
      {
        id: 'curr-average',
        value: data?.currentYear?.average?.length,
        color: '#DADEEF',
        ruleIds: data?.currentYear?.average,
        link: ' ',
      },
      {
        id: 'curr-need-intervention',
        value: data?.currentYear?.need_intervention?.length,
        color: '#EEBAC0',
        ruleIds: data?.currentYear?.need_intervention,
        link: ' ',
      },
    ],
    previousYearData: [
      {
        id: 'prev-good',
        value: data?.previousYear?.good?.length,
        color: '#6EC6BB',
        ruleIds: data?.previousYear?.good,
        link: ' ',
      },
      {
        id: 'prev-average',
        value: data?.previousYear?.average?.length,
        color: '#919DD0',
        ruleIds: data?.previousYear?.average,
        link: ' ',
      },
      {
        id: 'prev-need-intervention',
        value: data?.previousYear?.need_intervention?.length,
        color: '#E0808A',
        ruleIds: data?.previousYear?.need_intervention,
        link: ' ',
      },
    ],
  };

  return chartData;
};

export const getCareGapMemberSummaryIds = async ({
  eg_nid,
  max_claim_date,
  startDate,
  endDate,
}: {
  eg_nid: any;
  max_claim_date: any;
  startDate: any;
  endDate: any;
  setCareGapSummary?: any;
}): Promise<{
  noOfMemberIds: number;
  member_unique_ids: string[];
}> => {
  const res = await axios.post(
    properties.aiqBaseUrl +
      properties.careQualityInternalBasicUrl +
      properties.careQualityMemberSummaryIds,
    {
      eg_nid,
      max_claim_date,
      startDate,
      endDate,
    },
  );
  const data = res?.data?.data;

  return data;
};
